import './cookie-consent.css';

const dismissalKey = 'rill_analytics_notice_dismissed';
let notice: HTMLElement | undefined;

export function showCookieBanner(): void {
  if (!notice) {
    notice = document.createElement('aside');
    notice.className = 'analytics-notice';
    notice.setAttribute('aria-label', 'Analytics notice');
    notice.innerHTML = '<span>We use cookies for analytics. <a href="/privacy">Privacy Policy</a></span>';
    const close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss analytics notice');
    close.textContent = 'Got it';
    close.addEventListener('click', () => {
      notice!.hidden = true;
      try { window.localStorage.setItem(dismissalKey, '1'); } catch { /* Dismiss for this visit when storage is unavailable. */ }
    });
    notice.appendChild(close);
    document.body.appendChild(notice);
  }
  notice.hidden = false;
}

export async function startCookieConsent(): Promise<void> {
  try { if (window.localStorage.getItem(dismissalKey) === '1') return; } catch { /* Show without persistence. */ }
  showCookieBanner();
}
